import React from "react";
import ShopifyLogo from "./ShopifyLogo";
import OptimizelyLogo from "./OptimizelyLogo";
import SalesforceLogo from "./SalesforceLogo";
import MagentoLogo from "./MagentoLogo";

export { ShopifyLogo, OptimizelyLogo, SalesforceLogo, MagentoLogo };

type Props = { className?: string; size?: number };

export const AppLogo: React.FC<{ appKey: string } & Props> = ({ appKey, ...rest }) => {
  const key = appKey.toLowerCase();
  if (key.includes("shopify")) return <ShopifyLogo {...rest} />;
  if (key.includes("optimizely") || key.includes("optimziely")) return <OptimizelyLogo {...rest} />;
  if (key.includes("salesforce")) return <SalesforceLogo {...rest} />;
  if (key.includes("magento") || key.includes("megento")) return <MagentoLogo {...rest} />;
  return null;
};
